import FetchProxy from "./FetchProxy";

export default class RememberPassword {
    formSelector =".js-login-form";
    buttonSelector = ".js-remember-password-btn";
    successDivSelector = ".alert-success";

    /**
     * Proxy para hacer llamdas a fetch
     * @type {null}
     */
    fetchProxy=null;

    debug=true;


    constructor() {
        this.fetchProxy=new FetchProxy();
    }

    get$Form() {
        if (this.$_form==null) {
            this.$_form=$(this.formSelector);
            this.log("form=" + this.formSelector);
        }
        return this.$_form;
    }

    onLoginSuccess() {
        this.log("logging ok");
        $(this.successDivSelector).html('Si el email está registrado se enviará un correo con las instrucciones para obtener una nueva contraseña').show();
    }

    // Loguea en consola el mensaje. Sólo útil en depuración
    log(message) {
        if (this.debug) {
            console.log(message);
        }
    }

    t(s) {
        return s
    }

    isMail(email) {
        if (email == "" || (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))){

            return (true)
        } else {


            return (false);
        }
    }

    async fetchUrlPostUrlEncoded(url, postdataobj, params) {
        let result = await this.fetchProxy.fetchUrlPostUrlEncoded(url, postdataobj, params);
        return result;
    }

    /**
     * in is [ {name:1,value:4} ] and out is {"name":1}
     * @param nameValuePair
     * @returns {{}|*}
     */
    getAsPureArray(nameValuePair) {
        let result={};
        nameValuePair.forEach(function(nameValue, index) {
            result[nameValue.name]=nameValue.value;
        });
        return result;
    }

    async validateAndRememberPassword() {
        let me = this;
        let $form = this.get$Form();
        let request = $form.serializeArray();
        let namesFormMultiple = {};

        let restUrl = me.restUrl;
        if (restUrl == null) {
            restUrl = $(this.formSelector).attr("action");
        }
        // Para los elementos múltiples crea un array
        $(me.buttonSelector).prop("disabled", true);
        $form.find(".js-login-error").html("").hide();
        $form.find(this.successDivSelector).html("").hide();


        try {
            //restUrl='https://api.spotify.com/v1/artists/0OdUWJ0sBjDrqHygGUXeCFcdsds';
            let requestPureArray = this.getAsPureArray(request);
            let response = await this.fetchUrlPostUrlEncoded(restUrl, requestPureArray);
            let data = await response.json();
            if (this.isMail(requestPureArray.user_to_remember)) {
                me.onLoginSuccess();
            } else {
                let errorMessages = { "0": {"errorMessage": "El formato del email no es válido" } };
                me.onLoginError(errorMessages);
            }
        } catch (e) {
            me.onLoginError(e.errorMessages);
        }
        $(me.buttonSelector).prop("disabled", false);
    }

    /**
     * Se ha producido un error al hacer el login. Se muestra el mensaje de error
     * @param messages
     */
    onLoginError(messages) {
        let $form = this.get$Form();
        let message=this.t("Error al enviar los datos");
        try {
            message = messages[0]["errorMessage"];
        } catch(e) {

        }
        $form.find(".js-login-error").html(message).show();
    }

    compruebaCamposRememberPasswordEmail() {
        var vall = document["remember-email-form"];
        var nombre;
        var msgError=false;
        var newLine = "</br>";
        var strError="";
        var error=false;

        var popup=alert;
        nombre ="user_to_remember";
        if ( vall[ nombre ].value == "") {
            popup("Debe rellenar el campo del E-mail.");
            return false;
        }

        if (!this.validar_email(vall[ nombre ].value)) {
            popup("Introduzca un E-mail correcto.");
            return false;
        }
        //return false;
        return true;
    }
    validar_email(email) {
        var regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email) ? true : false;
    }

    /**
     * Inicializa los eventos del formulario para que cuando se pulse en "enviar" se activen los eventos necesarios
     */
    initEvents() {
        var me = this;
        $(this.buttonSelector).click(()=> {
            if (me.compruebaCamposRememberPasswordEmail()) {
                this.validateAndRememberPassword();
            }
            return false;
        })
    }
}